<template>
  <div>
  <!-- MAIN -->
  <div class="breadcrumbs ace-save-state" id="breadcrumbs">
    <ul class="breadcrumb">
      <li>
        <i class="ace-icon fa fa-home home-icon"></i>
        <a href="#/">ダッシュボード</a>
      </li>
      <router-link tag="li" :to="{name: 'groupedit', query: { id: groupId }}">
        <a>ゲートグループ一編集</a>
      </router-link>
      <li class="active">ユーザーの関連付けを追加</li>
    </ul><!-- /.breadcrumb -->
  </div>
  <div class="page-header">
    <div class="checkbox">
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace userId" checked="checked" @click="addRomoveScorp('userId', 'userId')">
        <span class="lbl">ユーザーID</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace name" checked="checked" @click="addRomoveScorp('name', 'name')">
        <span class="lbl">ユーザー名</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace furigana" checked="checked" @click="addRomoveScorp('furigana', 'furigana')">
        <span class="lbl">ユーザー名ふりがな</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace option1" checked="checked" @click="addRomoveScorp('option1', 'option1')">
        <span class="lbl">備考.1</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace option2" checked="checked" @click="addRomoveScorp('option2', 'option2')">
        <span class="lbl">備考.2</span>
      </label>
      <span class="input-icon search-box">
        <input type="text" placeholder="選択項目にチェックして検索" class="nav-search-input" id="nav-search-input" autocomplete="off">
        <i class="ace-icon fa fa-search nav-search-icon"></i>
      </span>
      <button class="btn-cusstom green-btn" type="button" @click="search()">検索</button>
      <button class="btn-cusstom green-btn" type="button" href="#process" data-toggle="modal" @click="resetStatus()">チェックしたユーザーを追加する</button>
      <button class="btn-cusstom black-btn pull-right" type="button" @click="cancel()">ゲートグループ編集画面に戻る</button>
    </div>
  </div><!-- /.page-header -->
  <!-- END MAIN -->
  <div class="page-content">
    <div class="alert alert-danger" v-if="errorMessageLogs!==''">
      {{ errorMessageLogs }}
    </div>
    <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
    <div class="scroll-data-content">
        <div class="pull-right">
          <a class="option_button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false">表示オプション&nbsp;
            <i class="bigger-110 ace-icon fa fa-angle-down" data-icon-hide="ace-icon fa fa-angle-up" data-icon-show="ace-icon fa fa-angle-down"></i>
          </a>
        </div>
        <div class="clearfix" style="clear:both">
          <div id="accordion">
            <div class="panel-collapse collapse" id="collapseOne" aria-expanded="false" style="height: 0px;">
              <div class="panel-body">
                <div class="control-group">
                  <label class="control-label bolder blue display_block">表示項目</label>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_id" type="checkbox" class="ace" disabled checked>
                      <span class="lbl"> ユーザーID</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_name" type="checkbox" @click="ShowHideColumn" class="ace" checked value="name" v-model="checkedColumnNames">
                      <span class="lbl"> ユーザー名</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_furigana" type="checkbox" class="ace" @click="ShowHideColumn" checked value="furigana" v-model="checkedColumnNames">
                      <span class="lbl">ユーザー名ふりがな</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_option1" type="checkbox" class="ace" @click="ShowHideColumn" checked value="option1" v-model="checkedColumnNames">
                      <span class="lbl">備考.1</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_option2" type="checkbox" class="ace" @click="ShowHideColumn" checked value="option2" v-model="checkedColumnNames">
                      <span class="lbl">備考.2</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_status" type="checkbox" class="ace" @click="ShowHideColumn" checked value="status" v-model="checkedColumnNames">
                      <span class="lbl"> ステータス</span>
                    </label>
                  </div>
                </div>
                <div class="control-group">
                  <label class="control-label bolder blue display_block">ページことに表示する項目</label>
                  <select id="pageSizeOptions" class="first-child last-child" @change="handleSizeChange" v-model="selected">
                    <option v-for="pageSize in pageSizeOptions" v-bind:value="pageSize" v-bind:key="pageSize">
                    {{ pageSize }} 件
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <table id="simple-table" class="table  table-bordered table-hover dataTable" v-if="list!=null">
          <thead>
            <tr>
              <th class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" v-model="selectAll">
                  <span class="lbl"></span>
                </label>
              </th>
              <th id="user_id" class="user_id sorting" @click="sort('userId', 'user_id')">ユーザーID</th>
              <th id="user_name" class="user_name sorting" @click="sort('name', 'user_name')" v-bind:class="{'none': checkColumnShowHide('name')}">ユーザー名</th>
              <th id="user_furigana" class="user_furigana sorting" @click="sort('furigana', 'user_furigana')" v-bind:class="{'none': checkColumnShowHide('furigana')}">ユーザー名ふりがな</th>
              <th id="user_option1" class="user_option1 sorting" @click="sort('option1', 'user_option1')" v-bind:class="{'none': checkColumnShowHide('option1')}">備考.1</th>
              <th id="user_option2" class="user_option2 sorting" @click="sort('option2', 'user_option2')" v-bind:class="{'none': checkColumnShowHide('option2')}">備考.2</th>
              <th id="user_status" class="center user_status sorting" @click="sort('isValid', 'user_status')" style="width:100px" v-bind:class="{'none': checkColumnShowHide('status')}">ステータス</th>
              <th style="text-align:center;width:100px">アクション</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in list" :key="index">
            <tr class="existItem" v-bind:class="{'selected': rowSelectedExistUser(item.userId)}" :id="item.userId" v-if="rowSelectedExistUser(item.userId)">
              <td class="center">
                <label class="pos-rel">
                  <input type="checkbox" disabled class="ace" :value="item.userId" v-model="existUserId">
                  <span class="lbl"></span>
                </label>
              </td>
              <td class="user_id">
                {{item.userId}}
              </td>
              <td class="user_name" v-bind:class="{'none': checkColumnShowHide('name')}">
                {{item.name}}
              </td>
              <td class="user_furigana" v-bind:class="{'none': checkColumnShowHide('furigana')}">{{item.furigana}}</td>
              <td class="user_option1" v-bind:class="{'none': checkColumnShowHide('option1')}">{{item.option1}}</td>
              <td class="user_option2" v-bind:class="{'none': checkColumnShowHide('option2')}">{{item.option2}}</td>
              <td class="center user_status" v-bind:class="{'none': checkColumnShowHide('status')}">
                <span v-if="item.isValid">有効</span>
                <span v-else >無効</span>
              </td>
              <td style="text-align:center">
                <a class="btn-cus-delete btn-right btn-delete" href="#processDelete" data-toggle="modal" @click="setTempData(tempGroupPassages[item.userId], item.userId)">解除</a>
              </td>
            </tr>
            <tr v-bind:class="{'selected': rowSelected(item.userId)}" :id="item.userId" v-else>
              <td class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" :value="item.userId" v-model="selectedUserId">
                  <span class="lbl"></span>
                </label>
              </td>
              <td class="user_id">
                {{item.userId}}
              </td>
              <td class="user_name" v-bind:class="{'none': checkColumnShowHide('name')}">
                {{item.name}}
              </td>
              <td class="user_furigana" v-bind:class="{'none': checkColumnShowHide('furigana')}">{{item.furigana}}</td>
              <td class="user_option1" v-bind:class="{'none': checkColumnShowHide('option1')}">{{item.option1}}</td>
              <td class="user_option2" v-bind:class="{'none': checkColumnShowHide('option2')}">{{item.option2}}</td>
              <td class="center user_status" v-bind:class="{'none': checkColumnShowHide('status')}">
                <span v-if="item.isValid">有効</span>
                <span v-else >無効</span>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <table id="simple-table" class="table  table-bordered table-hover dataTable" v-else>
          <thead>
            <tr>
              <th class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace">
                  <span class="lbl"></span>
                </label>
              </th>
              <th>ユーザーID</th>
              <th>ユーザー名</th>
              <th>ユーザー名ふりがな</th>
              <th>備考.1</th>
              <th>備考.2</th>
              <th>ステータス</th>
            </tr>
          </thead>
          <tbody>
            <tr><td colspan="7">{{ message }}</td></tr>
          </tbody>
        </table>
    </div><!-- /.row -->
    <div class="row pd-t-10">
      <div class="col-xs-12">
        <div class="dataTables_paginate paging_simple_numbers" v-if="pages>0">
          <paginate
            :page-count="pages"
            :page-range="3"
            :margin-pages="2"
            :click-handler="handleCurrentChange"
            :prev-text="'<<'"
            :next-text="'>>'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
  <!-- プロフィールModal -->
  <div id="process" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          <h3 class="smaller lighter frofile-title no-margin">ユーザーの関連付けを追加</h3>
        </div>
        <div class="modal-body">
          <span class="progress-question">チェックしたゲートを追加しますか？</span>
          <div class="progress" v-bind:class="{'progress-striped':!success , active:!success, hide:!success}">
            <div class="progress-bar" :style="progressWidth">
            <span>{{ Math.round(progress) }}%</span>
            </div>
          </div>
          <span class="success-label" v-if="successUser>0">{{countUser}}件中{{successUser}}件を追加しました。</span>
          <div v-if="errorMessage.length>0">
          <span class="error-box-title">追加失敗</span>
          <div class="error-box">
            <template v-for="item in errorMessage">
              <p v-html="item" :key="item"></p>
            </template>
          </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success">OK</button>
          <button class="btn btn-sm btn-danger pull-right" style="width:100px" v-if="!success" :disabled="isDisabled" @click="addUserToGate()">実行</button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div>
  <div id="processDelete" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          <h3 class="smaller lighter frofile-title no-margin">関連付け解除</h3>
        </div>
        <div class="modal-body">
          <span class="progress-delete-question">{{tempUserId}}との関連付けを解除しますか？</span>
        </div>
        <div class="modal-footer">
          <button class="btn btn-sm btn-danger pull-right" style="width:100px" @click="deleteGroupPassage(tempGroupPassageId, tempUserId)" data-dismiss="modal">解除</button>
        </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'

export default {
  data () {
    return {
      list: null,
      errorMessageLogs: '',
      checkedColumnNames: [
        'name',
        'furigana',
        'option1',
        'option2',
        'status'
      ],
      listUserGroup: null,
      scorp: ['userId', 'name', 'furigana', 'option1', 'option2'],
      groupId: '',
      total: 0,
      pages: 0,
      error: null,
      pageSizeOptions: [25, 50, 100, 1000],
      listQuery: {
        currPage: 1,
        pageSize: 100
      },
      progress: 0,
      selected: 100,
      selectedUserId: [],
      existUserId: [],
      tempGroupPassages: {},
      success: false,
      loading: false,
      isDisabled: false,
      errorMessage: [],
      successUser: 0,
      errorName: '',
      countUser: 0,
      exeCount: 0,
      percent: 0,
      userPage: 0,
      userDataLoad: 0,
      message: 'データー取得中',
      tempGroupPassageId: '',
      tempUserId: ''
    }
  },
  // countUserとはチェックしたアイテム数。
  // exeCountとはAPI実行回数、デフォルトの値は０です。
  // 一回APIを実行が終わるとexeCountに１をプラスする。
  // 全部APIを実行が終わるとexeCountの値は０にリセットする。
  // exeCount<countUserの時は次のAPI実行。
  // exeCount===countUserの時(全部APIを実行が終わったの時)は変数の値リセットする。
  watch: {
    'checkedColumnNames': 'updateChecked',
    exeCount: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.countUser) {
        vm.addUser(this.selectedUserId[newVal], vm.percent, newVal)
      } else if (newVal > 0 && newVal === vm.countUser) {
        this.exeCount = 0
        this.success = true
        this.selectedUserId = []
      }
    },
    userDataLoad: function (newVal, oldVal) {
      if (newVal > 0 && newVal < this.userPage) {
        this.getInforUserGroup(this.groupId, newVal + 1)
      }
    }
  },
  created () {
    if (typeof localStorage.pageSizeGroupUserAdd === 'undefined') {
      localStorage.setItem('pageSizeGroupUserAdd', 100)
      this.selected = localStorage.pageSizeGroupUserAdd
    } else {
      this.selected = localStorage.pageSizeGroupUserAdd
    }
    if (typeof localStorage.groupUserAddSortKey === 'undefined') {
      localStorage.setItem('groupUserAddSortKey', 'userId')
    }
    if (typeof localStorage.groupUserAddSortName === 'undefined') {
      localStorage.setItem('groupUserAddSortName', 'desc')
    }
    if (typeof localStorage.checkedGroupUserAdd === 'undefined') {
      localStorage.setItem('checkedGroupUserAdd', this.checkedColumnNames)
    } else {
      var tempData = []
      this.checkedColumnNames.forEach(function (item) {
        if (localStorage.checkedGroupUserAdd.indexOf(item) !== -1) {
          tempData.push(item)
        }
      })
      this.checkedColumnNames = tempData
    }
    this.getList()
    this.fetchData()
  },
  mounted () {
    var vm = this
    $('#nav-search-input').keyup(function (e) {
      if (e.keyCode === 13) {
        vm.search()
      }
    })
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    },
    selectAll: {
      get: function () {
        // true：帰ってきたら一番上の全件チェックボックスはチェックをつける。
        // false：帰ってきたら一番上の全件チェックボックスはチェックをつけない。
        // selectedUserIdとは、ユーザーがチェックボックスをチェックした数。
        // selectedUserIdが0より大きい時はチェックをつけない（false）
        // selectedUserIdが１以上の時は、次のロジックで判定する。
        // existItemとは、カレントページで元々チェックされているチェックボックスの数。
        // list.lengthとは「ページオプション」の「ページことに表示する項目」の数値。
        // selectedUserId + existItemの結果が、list.length以上であれば、true、list.length未満であれば、false。
        if (this.selectedUserId.length > 0) {
          var existItem = $('tr.existItem').length
          return this.list ? (this.selectedUserId.length + existItem) >= this.list.length : false
        } else {
          return false
        }
      },
      set: function (value) {
        var vm = this
        var selectedUserId = []
        if (value) {
          this.list.forEach(function (item) {
            if (!vm.rowSelectedExistUser(item.userId)) {
              selectedUserId.push(item.userId)
            }
          })
        }
        this.selectedUserId = selectedUserId
      }
    }
  },
  methods: {
    setTempData (groupPassageId, userId) {
      this.tempGroupPassageId = groupPassageId
      this.tempUserId = userId
    },
    deleteGroupPassage (groupPassageId, userId) {
      this.$http.delete(Config.GROUPS_PASSAGE_API + '/' + encodeURIComponent(groupPassageId))
        .then(response => {
          this.existUserId.splice(this.existUserId.indexOf(userId), 1)
          this.getList()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // １ページに表示する項目数
    handleSizeChange () {
      this.listQuery.pageSize = $('#pageSizeOptions').val()
      localStorage.setItem('pageSizeGroupUserAdd', this.listQuery.pageSize)
      this.listQuery.currPage = 1
      this.pages = 0
      this.getList()
    },
    updateChecked () {
      localStorage.setItem('checkedGroupUserAdd', this.checkedColumnNames)
    },
    checkColumnShowHide (columnName) {
      if (localStorage.checkedGroupUserAdd.indexOf(columnName) !== -1) {
        return false
      } else {
        return true
      }
    },
    resetStatus () {
      $('.progress').addClass('hide')
      $('.progress-question').html('チェックしたユーザーを追加しますか？')
      this.progress = 0
      this.success = false
      this.isDisabled = false
      this.errorMessage = []
      this.successUser = 0
      this.countUser = 0
    },
    cancel () {
      this.$router.push({name: 'groupedit', query: { id: this.groupId }})
    },
    fetchData () {
      var data = this.$route.query
      this.groupId = data.id
      this.userPage = data.userPage
      if (this.userPage > 0) {
        this.getInforUserGroup(this.groupId, 1)
      }
    },
    getInforUserGroup (groupId, page) {
      var vm = this
      this.$http.get(Config.GROUPS_PASSAGE_API + '?groupId=' + encodeURIComponent(groupId) + '&limit=25&page=' + page)
        .then(response => {
          console.log(response)
          vm.userDataLoad++
          vm.listUserGroup = response.body.groupPassages
          if (vm.listUserGroup.length > 0) {
            for (var i = 0; i < vm.listUserGroup.length; i++) {
              var userId = vm.listUserGroup[i].userId
              vm.existUserId.push(vm.listUserGroup[i].userId)
              this.$set(vm.tempGroupPassages, userId, vm.listUserGroup[i].groupPassageId)
            }
          }
        })
        .catch(error => {
          vm.userDataLoad++
          console.log(error)
        })
    },
    rowSelected (userId) {
      if (jQuery.inArray(userId, this.selectedUserId) !== -1) {
        return true
      } else {
        return false
      }
    },
    rowSelectedExistUser (userId) {
      if (jQuery.inArray(userId, this.existUserId) !== -1) {
        return true
      } else {
        return false
      }
    },
    addUser (userId, percent, i) {
      var vm = this
      this.$http.post(Config.GROUPS_PASSAGE_API, {groupId: this.groupId, userId: userId})
        .then(response => {
          this.$set(vm.tempGroupPassages, userId, response.body.groupPassageId)
          this.loading = false
          this.existUserId.push(userId)
          this.progress += percent
          this.successUser += 1
          this.exeCount++
        })
        .catch((error) => {
          this.loading = false
          this.progress += percent
          switch (error.status) {
            case 400:
              this.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              break
            case 409:
              this.errorName = '通行権限が重複しています。'
              break
            case 420:
              this.errorName = 'ユーザー登録数が上限に達しています。'
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = userId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, i, rowstatus)
          this.exeCount++
        })
    },
    addUserToGate () {
      var vm = this
      vm.isDisabled = true
      if (this.selectedUserId.length > 0) {
        this.countUser = this.selectedUserId.length
        $('.progress').removeClass('hide')
        $('.progress-question').html('処理状況')
        vm.percent = (100 / this.selectedUserId.length)
        vm.addUser(this.selectedUserId[0], vm.percent, 0)
      } else {
        alert('少なくてもユーザーを１つ選んでください。')
      }
    },
    addRomoveScorp (classname, scorpname) {
      if ($('.' + classname).prop('checked')) {
        this.scorp.push(scorpname)
      } else {
        this.scorp.splice($.inArray(scorpname, this.scorp), 1)
      }
    },
    search () {
      this.loading = true
      this.errorMessageLogs = ''
      if (this.scorp.length > 0) {
        $('#simple-table').find('tr.detail-row').removeClass('open')
        window.scrollTo(0, 0)
        this.listQuery.currPage = 1
        this.pages = 0
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
        this.$http.get(Config.USERS_LIST_API + '?limit=' + localStorage.pageSizeGroupUserAdd + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.groupUserAddSortName + ':' + localStorage.groupUserAddSortKey + '&isValid=true')
          .then(response => {
            if (response.body.maxRecords > 0) {
              this.loading = false
              this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizeGroupUserAdd)
              this.list = response.body.users
              console.log(response)
            } else {
              this.loading = false
              this.list = null
              this.pages = 0
              this.message = '該当するデーターがありません。'
            }
          })
          .catch((error) => {
            this.loading = false
            this.list = null
            this.pages = 0
            this.message = '該当するデーターがありません。'
            switch (error.status) {
              case 400:
                this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
              case 404:
                this.errorMessageLogs = '該当するデーターがありません。'
                break
              case 500:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
          })
      } else {
        alert('少なくても検索項目を１つ選んでください。')
        this.loading = false
      }
    },
    sort (sortkey, elementname) {
      this.loading = true
      if ($('#' + elementname).hasClass('sorting_asc')) {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_asc')
        $('#' + elementname).addClass('sorting_desc')
        localStorage.setItem('groupUserAddSortName', 'desc')
        localStorage.setItem('groupUserAddSortKey', sortkey)
      } else {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_desc')
        $('#' + elementname).addClass('sorting_asc')
        localStorage.setItem('groupUserAddSortName', 'asc')
        localStorage.setItem('groupUserAddSortKey', sortkey)
      }
      this.getList()
    },
    handleCurrentChange (val) {
      this.selectedUserId = []
      this.listQuery.currPage = val
      this.getList()
      window.scrollTo(0, 0)
    },
    ShowHideColumn: function (e) {
      var $tbl = $('#simple-table')
      var colToHide = $tbl.find('.' + $(e.target).attr('name'))
      $(colToHide).toggle()
    },
    getList () {
      this.loading = true
      this.errorMessageLogs = ''
      if (this.list !== null) {
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
      } else {
        keyword = ''
      }
      this.$http.get(Config.USERS_LIST_API + '?limit=' + localStorage.pageSizeGroupUserAdd + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.groupUserAddSortName + ':' + localStorage.groupUserAddSortKey + '&isValid=true')
        .then(response => {
          if (response.body.maxRecords > 0) {
            this.loading = false
            this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizeGroupUserAdd)
            this.list = response.body.users
            console.log(response)
          } else {
            this.loading = false
            this.list = null
            this.pages = 0
            this.message = '該当するデーターがありません。'
          }
        })
        .catch((error) => {
          this.loading = false
          this.list = null
          this.pages = 0
          this.message = '該当するデーターがありません。'
          switch (error.status) {
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 404:
              this.errorMessageLogs = '該当するデーターがありません。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    }
  }
}
</script>

<style>
.btn-cus-delete {
  padding: 5px 15px;
}
.checkbox label, .radio label {
  padding-left: 10px!important
}
.checkbox-box{
  margin-right: 15px
}
.edit-bottom,.delete-bottom{
  width: 100%;
  margin-bottom: 15px
}
.fa-6{
  font-size: 3em;
}
.fa-3{
  font-size: 2em;
}
.table>tbody>tr>td{
  vertical-align: middle;
  padding: 5px;
  font-size: 16px;
}
.dataTables_paginate .pagination {
  margin: 0;
}
.table-bordered>tbody>tr>td{
  border-right:3px solid #fff;
}
.label-sm {
  padding: 10px;
  font-size: 16px;
  line-height: 1;
  height: auto;
}
.table-detail .profile-info-name{
  width: 195px
}
.device{
  margin-top: 50px;
  border-top: 2px solid #ccc
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle.collapsed{
  font-size: 18px
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle{
  font-size: 18px
}
.add-buttom{
  margin-bottom: 10px
}
.modal-content .form-horizontal .control-label{
  text-align: left;
}
.chosen-container-single .chosen-single{
  border-radius: 0px;
  height: 35px;
  font-size: 16px;
  line-height: 35px!important;
}
.chosen-container-single{
  width: 100%!important
}
.chosen-container{
  margin-bottom: 10px
}
.dataTable>thead>tr>th[class*=sorting_]{
  color: #707070
}
.modal-content .form-horizontal .control-label{
  text-align: left;
}
.chosen-container-single .chosen-single{
  border-radius: 0px;
  height: 35px;
  font-size: 16px;
  line-height: 35px!important;
}
.chosen-container-single{
  width: 100%!important
}
.chosen-container{
  margin-bottom: 10px
}
.dataTable>thead>tr>th[class*=sorting_]{
  color: #707070
}
</style>



// WEBPACK FOOTER //
// src/views/group/GroupUserAdd.vue